import Color from 'color'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { Size } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { TraceProps } from '@ocean/ui/dist/components/common/Skeleton/Skeleton.styled'
import { Wrapper as InfoListLabel } from 'layouts/infoLists/InfoListLabel/InfoListLabel.styled'

const { traceStyles } = common.skeletonStyles

type FormControlTraceProps = TraceProps & {
  size?: Size
}

export const FormControlTrace = styled.div<FormControlTraceProps>`
  ${traceStyles}

  ${({ theme, size }) => `
    height: ${theme.controlSize[size || Size.Medium]};
    border-radius: ${theme.borderRadius.base};
  `}
`

export const FilterSkeletonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.base};
    align-items: center;
    flex-direction: row;
  `}
`

export const FormSkeletonWrapper = styled.div`
  span[data-selector='ContentTrace'] {
    ${({ theme }) => `
      background-color: ${Color(theme.color.oceanDark).alpha(0.3)};
      margin-bottom: ${theme.space.mobile.nano};
    `}

    ${({ theme }) => media.sm`
      margin-bottom: ${theme.space.mobile.tiny};
    `}
  }
`

export const InfoListSkeletonWrapper = styled.div`
  ${({ theme }) => `
    ${InfoListLabel} {
      padding-bottom: ${theme.space.mobile.small};
    }
  `}

  ${media.sm`
    ${InfoListLabel} {
      padding-bottom: 0;
    }
  `}
`
